module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade bd-example-modal-lg",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "p-b-10"
  }, [_c('h5', [_c('span', {
    staticClass: "text-pink"
  }, [_vm._v("＊")]), _vm._v(" " + _vm._s(_vm.tooltip))])]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("套用門市")]), _vm._v(" "), _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      key: ("storeClass-" + index),
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n              " + _vm._s(storeClass.name) + "\n            ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "min-h-260"
  }, [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          取消\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.copyStore
    }
  }, [_vm._v("\n          確定\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("複製選取設定至其他店家")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f3d27f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/chooseStoreModal.vue
// module id = 2424
// module chunks = 1